import { Trans } from 'react-i18next'

import goodCompanyPNG from '~/assets/images/history/history-good-company.png'
import goodCompanyWEBP from '~/assets/images/history/history-good-company.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const GoodCompany = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: `You're in good company`,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={goodCompanyWEBP} type="image/webp" />
            <img src={goodCompanyPNG} alt="Good company" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="history" i18nKey="onboarding.historyGoodCompany.title" />
        </S.Title>

        <S.Subtitle>
          <Trans
            ns="history"
            i18nKey="onboarding.historyGoodCompany.subtitle"
          />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default GoodCompany
